var render = function render(_c, _vm) {
  return _c("article", { staticClass: "card text-left" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "section" }, [
      _c(
        "ol",
        {
          staticClass: "fa-ul margin-y-0",
          staticStyle: { "--fa-li-width": "3.5em" },
        },
        [
          _c("li", { staticClass: "margin-bottom-md" }, [
            _c(
              "span",
              {
                staticClass: "fa-li",
                staticStyle: { color: "var(--fa-dk-teal)" },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.parent.$v6.solid.faCheck },
                }),
              ],
              1
            ),
            _vm._v(
              "\n        Use Font Awesome Free in your commercial projects.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "margin-bottom-md" }, [
            _c(
              "span",
              {
                staticClass: "fa-li",
                staticStyle: { color: "var(--fa-dk-teal)" },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.parent.$v6.solid.faCheck },
                }),
              ],
              1
            ),
            _vm._v("\n        Use Font Awesome Free on your websites.\n      "),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "margin-bottom-md" }, [
            _c(
              "span",
              {
                staticClass: "fa-li",
                staticStyle: { color: "var(--fa-dk-teal)" },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.parent.$v6.solid.faCheck },
                }),
              ],
              1
            ),
            _vm._v("\n        Use FA Free in desktop apps.\n      "),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "margin-bottom-md" }, [
            _c(
              "span",
              {
                staticClass: "fa-li",
                staticStyle: { color: "var(--fa-dk-teal)" },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.parent.$v6.solid.faCheck },
                }),
              ],
              1
            ),
            _vm._v(
              "\n        Embed FA Free in your mobile and desktop apps.\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "margin-bottom-md" }, [
            _c(
              "span",
              {
                staticClass: "fa-li",
                staticStyle: { color: "var(--fa-dk-teal)" },
              },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: _vm.parent.$v6.solid.faCheck },
                }),
              ],
              1
            ),
            _vm._v(
              "\n        Embed FA Free in documents. (e.g. .pdf, .doc, etc.)\n      "
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function (_c, _vm) {
    return _c("div", { staticClass: "section" }, [
      _c("h2", { staticClass: "h5" }, [
        _c("span", { staticClass: "sr-only" }, [_vm._v("Font Awesome")]),
        _vm._v("\n      Free License Dos\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }